import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  root: {
    display: "flex"
  },
  table: {
    minWidth: 500
  },
  tableWrapper: {
    width: "100%"
  },
  tablePaper: {
    width: "100%",
    marginTop: theme.spacing(4)
  }
}));
